import type {
  PriceCategoryListSortColumn,
  SortOrder,
} from "Infrastructure/Api/Api";

export const PRICE_CATEGORIES_QUERY_KEYS = {
  all: ["PRICE_CATEGORIES"] as const,
  list: (
    offset?: number,
    limit?: number,
    searchQuery?: string,
    sortBy?: PriceCategoryListSortColumn,
    sortOrder?: SortOrder,
  ) =>
    [
      ...PRICE_CATEGORIES_QUERY_KEYS.all,
      "LIST",
      offset,
      limit,
      searchQuery,
      sortBy,
      sortOrder,
    ] as const,
} as const;
